import axios from 'axios';
import ApiUrl from './config';

export interface TournamentCategoryOverview {
  ageCategoryInTournamentId: number;
  weightCategoryInTournamentId: number;
  ageCategoryName: string;
  weightCategoryLabel: string;
  gender?: string | null;
  genderLabel?: string | null;
  mainBracketId?: number | null;
  leftRepechageBracketId?: number | null;
  rightRepechageBracketId?: number | null;
  playoffBracketId?: number | null;
  groupStageFinished?: boolean;
  format?: string | null;
  isApproved: boolean;
  /** В группе уже начали или досудили поединок — состав и сетка заморожены. */
  hasConductedMatches: boolean;
  /** Сколько человек уже попало в утверждённые поединки. */
  bracketParticipantCount: number;
  totalParticipants: number;
  remainingParticipants: number;
  eliminatedParticipants: number;
  isFinished: boolean;
}

export async function fetchCategoryOverviews(tournamentId: number): Promise<TournamentCategoryOverview[]> {
  const { data } = await axios.get<TournamentCategoryOverview[]>(
    `${ApiUrl}/api/Tournament/GetCategoryOverviews`,
    { params: { tournamentId } }
  );
  return data;
}
